const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

// // 人事管理
const user = r =>
  require.ensure(
    [],
    () => r(require('@/modules/zkCdpPage/personal/user.vue')),
    'personal'
  )
const area = r =>
  require.ensure(
    [],
    () => r(require('@/modules//zkCdpPage/personal/area.vue')),
    'personal'
  )
const department = r =>
  require.ensure(
    [],
    () => r(require('@/modules//zkCdpPage/personal/department.vue')),
    'personal'
  )

const personalConfig = {
  path: '/personal',
  name: 'personal',
  component: Layout,
  meta: {
    auth: true,
    id: 'sys-menu-a-1',
    breadcrumbShow: false
  },
  redirect: '/personal/user',
  children: [
    {
      path: '/personal/user',
      name: 'user',
      component: user,
      meta: {
        id: 'sys-menu-a-1',
        auth: true
      }
    },
    {
      path: 'department',
      name: 'department',
      component: department,
      meta: {
        id: 'sys-menu-a-2',
        auth: true
      }
    },
    {
      path: 'area',
      name: 'area',
      component: area,
      meta: {
        id: 'sys-menu-a-3',
        auth: true
      }
    }
  ]
}
export default personalConfig



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/personal.js